import styled from 'styled-components';

export const HeaderButtonsContainer = styled.nav`
  & ul.buttonBox {
    display: flex;
    justify-content: space-around;
    list-style: none;
    font-size: 14px;
    color: ${props => props.theme.headerButtonColor};
    cursor: pointer;
    margin: 0;
    padding: 0;
    cursor: pointer;
    height: 100%;
    line-height: 1;
  }

  & ul.buttonBox > li {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & ul.buttonBox > li:hover {
    box-shadow: inset 0px -12px 7px -12px #66bfef, inset 0px -1px 0px 0px #02c5ff;
  }

  & ul.buttonBox > li:hover > a {
    text-decoration: none;
  }

  & ul.buttonBox > li > .buttonName {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${props => props.theme.headerButtonColor};
  }

  & ul.buttonBox > li.logout-button > svg {
    transform: rotate(180deg);
  }

  @media (min-width: 960px) {
    & ul.buttonBox > li:nth-child(1) {
      width: 68px;
    }
    
    & ul.buttonBox > li:nth-child(2) {
      width: 85px;
    }
  }

  @media (max-width: 960px) {
    & ul.buttonBox > li:nth-child(1) {
      width: 100px;
    }
    
    & ul.buttonBox > li:nth-child(2) {
      width: 100px;
    }
  }
`